const ENV_OPTIONS = {
  prefix: '__ly_cache_store',
  userID: '__ly_user_id',
  keys: {
    token: '__ly_token',
  },
  global: window as any,
  setStorage: (key: string, value: string) => localStorage.setItem(key, value),
  getStorage: (key: string) => localStorage.getItem(key),
  removeStorage: (key: string) => localStorage.removeItem(key),
  clearStorage: () => localStorage.clear(),
};

export const STORE_KEYS: any = ENV_OPTIONS.keys;
export const userID: any = ENV_OPTIONS.userID;

// 初始化
(function () {
  const _random = (Math.random() * 100) % 100;
  ENV_OPTIONS.prefix = `__${_random}_cache_storage`;
})();

/**
 * 初始化
 * @param options
 */
export function initStoreEnv(options?: Partial<typeof ENV_OPTIONS>) {
  Object.assign(ENV_OPTIONS, options);
  Object.assign(STORE_KEYS, (options || {}).keys || {});
}


export function getLocalStorage<T = any>(
  key: string,
  through = false
): T | null {
  if (!through) {
    const global = ENV_OPTIONS.global;
    global[ENV_OPTIONS.prefix] = global[ENV_OPTIONS.prefix] || {};
    const _tmp = global[ENV_OPTIONS.prefix][key];
    if (typeof _tmp !== 'undefined') {
      return _tmp as T;
    }
  }

  const getStorage = ENV_OPTIONS.getStorage;
  let row = getStorage(key);
  if (row) {
    try {
      row = JSON.parse(row);
    } catch (e) { }
  }
  return row as T | null;
}
export function setLocalStorage(key: string, data: any) {
  const global = ENV_OPTIONS.global;
  const setStorage = ENV_OPTIONS.setStorage;
  global[ENV_OPTIONS.prefix] = global[ENV_OPTIONS.prefix] || {};
  global[ENV_OPTIONS.prefix][key] = data;

  if (typeof data === 'object') {
    data = JSON.stringify(data);
  }
  setStorage(key, data);
}

export function removeLocalStorage(key: string) {
  const global = ENV_OPTIONS.global;
  const removeStorage = ENV_OPTIONS.removeStorage;
  global[ENV_OPTIONS.prefix] = global[ENV_OPTIONS.prefix] || {};
  global[ENV_OPTIONS.prefix][key] = global.undefined;
  removeStorage(key);
}

export function clearLocalStorage(key: string) {
  const global = ENV_OPTIONS.global;
  const clearStorage = ENV_OPTIONS.clearStorage;
  global[ENV_OPTIONS.prefix] = {};
  clearStorage();
}
